module.exports = __webpack_public_path__ + "static/media/profilbild_placeholder.bb4b1ae9.png";